import { Component,OnInit,OnDestroy  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Result } from '../../servicios/servers.service';
import { AlertService } from "../../servicios/alert.service";
import { PersonaService } from '../../servicios/persona.service';
import { loading_show, loading_hide } from '../../app.helpers';
import { Usuario } from '../../models/Usuario';

declare var jQuery:any;

@Component({
    selector: 'verificarEmail',
    templateUrl: 'verificarEmail.template.html'
})
export class verificarEmailComponent implements OnInit, OnDestroy {

    model: any = {};
    loading = false;
    returnUrl: string;
    token:string;
    error:boolean = null;
    private sub: any;
    
 
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private PersonaService: PersonaService,
        private alertService: AlertService
    ) {  }

    ngOnInit() {
        this.model.mensaje = "Verificando Email de Recuperación";
        
        this.sub = this.route.params.subscribe(params => {
           
            this.token = params['token']; 
            this.verificarEmail();
            
         });
        

    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    recuperarClave() {

        this.loading = true;     
        var object = {
            clave: this.model.clave,
            token:this.token
        };

        this.PersonaService.recuperarClave(object,(data: any) => {
            
            if (data.isOk) {

                if(data.Mensaje == "ok"){

                    this.alertService.success("Clave Recuperada Correctamente");
                    this.model = {};
                    setTimeout(()=>{
                        this.router.navigate(['/login']);
                    },3000)
    
                }else{
                    this.loading = false;     
                    this.alertService.error(data.Mensaje);
                }
                

            }else{
                this.loading = false;     
                this.alertService.error("Error desconocido");
            }

                   

        });
    }

    verificarEmail() {

        this.loading = true;
        
        var object = {
            token:this.token
        };

        this.PersonaService.verificarEmail(object,(data: any) => {
            
            if (data.isOk) {

                if(data.Mensaje == "ok"){
                    this.error = false;

    
                }else{
                    this.error = true;
                    this.model.mensaje = data.Mensaje;
                    this.alertService.error(data.Mensaje);
                }
                

            }else{
                this.error = true;
                this.model.mensaje = data.Mensaje;
                this.alertService.error(data.Mensaje);
            }

            this.loading = false;            

        });
    }

 }


// WEBPACK FOOTER //
// ./src/app/views/verificarEmail/verificarEmail.component.ts